import { render } from "./CreateTemplate.vue?vue&type=template&id=710dd874&scoped=true"
import script from "./CreateTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTemplate.vue?vue&type=script&lang=js"

import "./CreateTemplate.vue?vue&type=style&index=0&id=710dd874&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710dd874"]])

export default __exports__